import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.TICKET_SEARCHING:
            return { ...state, loading: true };

        case types.TICKET_RESET:
        case types.TICKET_SEARCHING_COMPLETED:
            return { loading: false };

        case types.TICKET_SEARCHING_CANCELLED:
            if (!state.loading) {
                return { loading: false, err: action.err };
            }
            return state;

        case types.TICKET_SEARCHING_FAILED:
            return { loading: false, data: action.data, err: action.err };

        default:
            return state;
    }
};
